import type { Article } from "../../../../types/content";

const getHref = (isOmniEconomy: boolean, article?: Article) =>
  `https://om.omni.se/${isOmniEconomy ? "ekonomi" : "omni-mer"}?utm_source=editorial_poster&utm_channel=${isOmniEconomy ? "ekonomi_web" : "omni_web"}&utm_campaign=product_integrated&utm_content=${article?.article_id}&utm_term=acquisition`;

export { getHref };
